export type ContractDeliveryMethod = 'email' | 'portal' | 'both';
export const CONTRACT_DELIVERY_OPTIONS = [
    { value: 'email', label: 'Email public link', description: 'Review and sign without a portal account.' },
    { value: 'portal', label: 'Share to portal', description: 'Notify clients who already have portal access.' },
    { value: 'both', label: 'Email and portal', description: 'Send the public link and notify the portal.' },
];
export function contractDeliveryNeedsEmail(method: ContractDeliveryMethod): boolean {
    return method === 'email' || method === 'both';
}
export function contractDeliveryActionLabel(method: ContractDeliveryMethod): string {
    return method === 'email' ? 'Sign and email contract' : method === 'portal' ? 'Sign and share to portal' : 'Sign and send by email and portal';
}
export function contractDeliverySuccessMessage(method: ContractDeliveryMethod): string {
    return method === 'email' ? 'Contract emailed with a public signing link.' : method === 'portal' ? 'Contract shared to the portal.' : 'Contract emailed and shared to the portal.';
}
